import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { InfoTooltipProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import SimpleTooltip from "./tooltip";
import Icon from "../icon";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, placement, icon }) => {
  return (
    <SimpleTooltip text={text} placement={placement}>
      <Grid item className={cssExports.tooltipContent}>
        <Icon icon={icon ?? IconDefinitionConstants.WInfoCircleFill} className={cssExports.tooltipInfoIcon} />
      </Grid>
    </SimpleTooltip>
  );
};

export default InfoTooltip;
